import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

interface SubItem {
  name: string;
  href: string;
}

interface MenuItem {
  name: string;
  href: string;
  subItems?: SubItem[];
}

interface MegaMenuDrawerProps {
  isOpen: boolean;
  items: MenuItem[];
}

const MegaMenuDrawer = ({ isOpen, items }: MegaMenuDrawerProps) => {
  const [activeSubMenu, setActiveSubMenu] = useState<string | null>(null);

  if (!isOpen) return null;

  return (
    <div className="absolute top-full left-1/2 -translate-x-1/2 min-w-[200px] bg-background border border-border rounded-lg shadow-xl animate-slide-down z-50">
      <div className="p-4 space-y-1">
        {items.map((item) => (
          <div
            key={item.name}
            className="relative"
            onMouseEnter={() => item.subItems && setActiveSubMenu(item.name)}
            onMouseLeave={() => setActiveSubMenu(null)}
          >
            {item.subItems ? (
              <>
                <button
                  className="w-full flex items-center justify-between px-4 py-2 text-sm font-medium group"
                >
                  <span className="relative after:content-[''] after:absolute after:w-full after:scale-x-0 after:h-0.5 after:bottom-0 after:left-0 after:bg-black after:origin-bottom-right after:transition-transform after:duration-300 group-hover:after:scale-x-100 group-hover:after:origin-bottom-left">
                    {item.name}
                  </span>
                  <ChevronRight className="w-4 h-4" />
                </button>
                
                {/* Submenu */}
                {activeSubMenu === item.name && (
                  <div className="absolute left-full top-0 ml-1 min-w-[160px] bg-background border border-border rounded-lg shadow-xl z-50">
                    <div className="p-2 space-y-1">
                      {item.subItems.map((subItem) => (
                        <Link
                          key={subItem.name}
                          to={subItem.href}
                          className="block px-4 py-2 text-sm font-medium group/sub"
                        >
                          <span className="relative after:content-[''] after:absolute after:w-full after:scale-x-0 after:h-0.5 after:bottom-0 after:left-0 after:bg-black after:origin-bottom-right after:transition-transform after:duration-300 group-hover/sub:after:scale-x-100 group-hover/sub:after:origin-bottom-left">
                            {subItem.name}
                          </span>
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </>
            ) : (
              <Link
                to={item.href}
                className="block px-4 py-2 text-sm font-medium group/item"
              >
                <span className="relative after:content-[''] after:absolute after:w-full after:scale-x-0 after:h-0.5 after:bottom-0 after:left-0 after:bg-black after:origin-bottom-right after:transition-transform after:duration-300 group-hover/item:after:scale-x-100 group-hover/item:after:origin-bottom-left">
                  {item.name}
                </span>
              </Link>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MegaMenuDrawer;
